import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { STYLE_CONFIG } from './constants';
import './linear.scss';
export interface ILinear {
    style: 'dark' | 'light' | 'gradient';
}

const Linear = ({ style }: ILinear) => {
    let bgColorClassName = '';

    if (style === 'gradient') {
        bgColorClassName = 'eds-bg-color--ui-orange';
    }

    return (
        <div
            className="eds-progress-indicator--linear__rail"
            style={{
                backgroundColor: STYLE_CONFIG[style].railColor,
            }}
            aria-valuetext={gettext('In progress').toString()}
        >
            <div
                className={`eds-progress-indicator--linear__line eds-progress-indicator--linear-indeterminate__line ${bgColorClassName}`}
                style={{
                    backgroundColor: STYLE_CONFIG[style].stopColor,
                }}
            />
        </div>
    );
};

export default Linear;
